import {Injectable} from '@angular/core';
import {Helper} from 'appShared/classes';
import {PermissionRulesTrait} from 'appEntries/panel/traits';
import {BasePermissionService} from './base-permission.service';
import {AuthApiService} from '@spa/api';

@Injectable({
    providedIn: 'root'
})
export class SesPermissionService extends BasePermissionService {

    constructor(protected readonly authApiService: AuthApiService) {
        super(authApiService);
    }

    public isHasAccountView(): boolean {
        return Helper.getUnionStrategyPermissionsCheck(
            PermissionRulesTrait.getUserAccountViewPermissionRule().permissions,
            this.authUserPermissions
        );
    }

    public isHasAssignedFeedView(): boolean {
        return Helper.getUnionStrategyPermissionsCheck(
            PermissionRulesTrait.getAssignedFeedsToUsersViewPermissionRule().permissions,
            this.authUserPermissions
        );
    }

    public isHasUserView(): boolean {
        return Helper.getUnionStrategyPermissionsCheck(
            PermissionRulesTrait.getUserViewPermissionRule().permissions,
            this.authUserPermissions
        );
    }

    public isHasClientView(): boolean {
        return Helper.getUnionStrategyPermissionsCheck(
            PermissionRulesTrait.getClientViewPermissionRule().permissions,
            this.authUserPermissions
        );
    }

    public hasViewFeedPermission(): boolean {
        return Helper.getUnionStrategyPermissionsCheck(
            PermissionRulesTrait.getMarketDataFeedViewPermissionRule().permissions, this.authUserPermissions
        );
    }

    public hasSetMarkupPermission(): boolean {
        return Helper.getUnionStrategyPermissionsCheck(
            PermissionRulesTrait.getSetFeedMarkupPermissionRule().permissions, this.authUserPermissions
        );
    }

    public hasViewFeedPricePermission(): boolean {
        return Helper.getUnionStrategyPermissionsCheck(
            PermissionRulesTrait.getViewFeedPricePermissionRule().permissions, this.authUserPermissions
        );
    }

    public hasViewSubscriptionPricePermission(): boolean {
        return Helper.getUnionStrategyPermissionsCheck(
            PermissionRulesTrait.getViewSubscriptionPricePermissionRule().permissions, this.authUserPermissions
        );
    }

    public hasSetSubscriptionPricePermission(): boolean {
        return Helper.getUnionStrategyPermissionsCheck(
            PermissionRulesTrait.getSetSubscriptionPricePermissionRule().permissions, this.authUserPermissions
        );
    }

    public hasFeedManagementPermission(): boolean {
        return Helper.getUnionStrategyPermissionsCheck(
            PermissionRulesTrait.getMarketDataFeedManagementPermissionRule().permissions, this.authUserPermissions
        );
    }

    public hasRemoveFeedOrBundlePermission(): boolean {
        return Helper.getUnionStrategyPermissionsCheck(
            PermissionRulesTrait.getMarketDataFeedAndBundleRemoveBtnViewPermissionRule().permissions, this.authUserPermissions
        );
    }

    public hasViewPlatformFrontendPermission(): boolean {
        return Helper.getUnionStrategyPermissionsCheck(
            PermissionRulesTrait.getPlatformFrontendManagementPermissionRule().permissions, this.authUserPermissions
        );
    }

    public hasFeedBundleManagementPermission(): boolean {
        return Helper.getUnionStrategyPermissionsCheck(
            PermissionRulesTrait.getMarketDataFeedBundleManagementPermissionRule().permissions, this.authUserPermissions
        );
    }
}
